module.exports = __webpack_public_path__ + "img/1备份 2.d3a99bab.jpg";